/**
 * useTestMode — placeholder Test Mode hook.
 *
 * TODO (v3 future sprint): Replace this read-only stub with the full Test
 * Mode plumbing once the Test Mode admin module ships. Today it reads a
 * single boolean key out of the SystemSettings catalog so the Debug Panel
 * can be exercised end-to-end before the rest of the Test Mode work lands.
 */
import { useConfig } from '@/contexts/ConfigContext';

export interface TestModeState {
  enabled: boolean;
  /** Source field that drove the decision — useful for the Test Mode debug section. */
  source: 'systemSettings.testModeEnabled' | 'default';
}

export function useTestMode(): TestModeState {
  const { config } = useConfig();
  const raw = (config.systemSettings as Record<string, unknown> | undefined)?.['testModeEnabled'];
  if (raw === true || raw === 'true' || raw === 1 || raw === '1') {
    return { enabled: true, source: 'systemSettings.testModeEnabled' };
  }
  return { enabled: false, source: 'default' };
}
